<template>
    <main class="mt-5">
        <div class="card mt-3">
            <div class="d-flex justify-content-center">  
                <div class="alert alert-warning justify-content-center align-items-center" style="width: 100%;">  
                    <span class="font-weight-bold text-danger">توجه:</span>  
                    <span class="mr-1">تمامی مبالغ به  <span class="font-weight-bold">ریال</span> می‌باشد.</span>  
                </div>  
            </div>
            <div class="card-header border-0">
                <h5 class="card-title font-bold py-3">گزارش فروش صندوق دار</h5>
                <div style="flex: 1"></div>
                <button @click="print" class="btn btn-primary">
                    <span
                        style="transform: translateY(3px)"
                        class="feather-printer"
                    ></span>
                </button>
            </div>
            <div class="row px-4 not-in-print">
                <div class="row col-12">
                    <b-form-group class="col-4">
                    <multiselect
                        placeholder="انتخاب انبار"
                        v-model="selectedStore"
                        open-direction="bottom"
                        :options="stores"
                        label="label"
                        track-by="id"
                        :searchable="true"
                        :close-on-select="true"
                        :show-labels="false"
                        :disabled="disabled"
                    >
                        <template slot="noOptions"> موردی یافت نشد </template>
                        <template slot="noResult"> موردی یافت نشد </template>
                    </multiselect>
                    </b-form-group>
                    <DatePickerRange class="col-md-6" v-model="filterDate" />
                </div>
                <b-button
                    class="col-md-2"
                    variant="primary"
                    @click="doFilter"
                    :disabled="disabled"
                    >فیلترسازی</b-button
                >
            </div>
            <div id="print" class="p-4">
                <div class="print-only">
                    <h4>فروشگاه الینور</h4>
                </div>
                <br>
                <div
                    class="d-flex mb-3 mr-2-print"
                >
                    <span class="ml-1 font-bold">گزارش فروش صندوق دار</span>
                    <div v-if="filterDate.startDate">
                        <span>از</span>
                        <span class="font-weight-bold mx-1">تاریخ</span
                            ><span> {{ filterDate.startDate | persianDate }} </span>
                        </div>
                    <div class="mr-3" v-if="filterDate.endDate">
                        <span>تا</span>
                        <span class="font-weight-bold mx-1">تاریخ</span
                        ><span> {{ filterDate.endDate | persianDate }} </span>
                    </div>
                </div>
                <b-table
                    v-if="reports"
                    bordered
                    :items="reports"
                    striped
                    :fields="fields"
                    responsive
                >
                    <template v-slot:cell(sum_refund_today)="data">
                    {{ data.item.sum_refund_today * 10 | price }}
                    </template>
                    <template v-slot:cell(changes_amount)="data">
                    {{ data.item.changes_amount * 10 | price }}
                    </template>
                    <template v-slot:cell(today_sales_discount)="data">
                    {{ data.item.today_sales_discount * 10 | price }}
                    </template>
                    <template v-slot:cell(digipay_amount)="data">
                    {{ data.item.digipay_amount * 10 | price }}
                    </template>
                    <template v-slot:cell(total_sales_card_by_card)="data">
                    {{ data.item.total_sales_card_by_card * 10 | price }}
                    </template>
                    <template v-slot:cell(cashier_orders)="data">
                    {{ data.item.cashier_orders | price }}
                    </template>
                    <template v-slot:cell(total_sales_cash)="data">
                    {{ data.item.total_sales_cash * 10 | price }}
                    </template>
                    <template v-slot:cell(total_sales_pos)="data">
                    {{ data.item.total_sales_pos * 10 | price }}
                    </template>

                    <template v-slot:cell(total_sales_today_without_wallet)="data">
                    {{ data.item.total_sales_today_without_wallet * 10 | price }}
                    </template>
                    <template #bottom-row="data">
                    <b-td>جمع کل:</b-td>
                    <b-td>
                        {{ totals.total_orders | price }}
                    </b-td>
                    <b-td>
                        {{ totals.sum_sales_quantity_today | price }}
                    </b-td>
                    <b-td>
                        {{ totals.sum_refund_today * 10 | price }}
                    </b-td>
                    <b-td>
                        {{ totals.changes_amount * 10 | price }}
                    </b-td>
                    <b-td>
                        {{ totals.today_sales_discount * 10 | price }}
                    </b-td>
                    <b-td>
                        {{ totals.digipay_amount * 10 | price }}
                    </b-td>
                    <b-td>
                        {{ totals.total_sales_card_by_card * 10 | price }}
                    </b-td>
                    <b-td>
                        {{ totals.total_sales_cash * 10 | price }}
                    </b-td>
                    <b-td>
                        {{ totals.total_sales_pos * 10 | price }}
                    </b-td>
                    <b-td>
                        {{ totals.total_wallet * 10 | price }}
                    </b-td>
                    <b-td>
                        {{ totals.total_sales_today_without_wallet * 10 | price }}
                    </b-td>
                    </template>
                </b-table>
            <div v-if="!reports" class="alert alert-primary">در حال بارگزاری</div>
            </div>
        </div>
    </main>
</template>
<script>
    import { BTable, BFormGroup, BFormInput, BButton, BTd, BFormCheckbox } from "bootstrap-vue";
    import configProvider from "@@/core/configProvider";
    import reportMixin from "@@/core/mixins/reportMixin";
    import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";
    import DatePickerRange from "@@/core/components/shared/DatePickerRange/DatePickerRange";
    import CustomerSearch from "@@/core/components/shared/CustomerSearch/CustomerSearch";
    export default {
        name: "CashiersReport",
        components: {
            BTable,
            BFormGroup,
            BFormInput,
            ProductSearch,
            BButton,
            BTd,
            DatePickerRange,
            CustomerSearch,
            BFormCheckbox,
        },
        configProvider,
        data() {
            return {
                disabled: false,
                fields: [
                    {
                        key: "cashier_name",
                        label: "صندوق دار",
                    },
                    {
                        key: "cashier_orders",
                        label: "تعداد فاکتور",
                    },
                    {
                        key: "sum_sales_quantity",
                        label: "تعداد اقلام فروخته شده",
                    },
                    {
                        key: "sum_refund_today",
                        label: "مرجوعی ها",
                    },
                    {
                        key: "changes_amount",
                        label: "تعویضی ها",
                    },
                    {
                        key: "today_sales_discount",
                        label: "تخفیفات",
                    },
                    {
                        key: "digipay_amount",
                        label: "دیجی پی",
                    },
                    {
                        key: "total_sales_card_by_card",
                        label: "کارت به کارت",
                    },
                    {
                        key: "total_sales_cash",
                        label: "نقدی",
                    },
                    {
                        key: "total_sales_pos",
                        label: "پوز",
                    },
                    {
                        key: "total_wallet",
                        label: "از کیف پول",
                    },
                    {
                        key: "total_sales_today_without_wallet",
                        label: "فروش کلی",
                    },
                ],
                page: 1,
                reports: null,
                sortBy: null,
                sortDesc: null,
                totals: null,
                has_discount: null,
                selectedStore: null,
                stores: [],
                admins: [],
                admin_id: null,
                filterDate: {
                    endDate: "",
                    startDate: "",
                },
                filterSelectedCustomer: "",
                Variety_id: "",
                disabledRest: true,
            };
        },
        mixins: [reportMixin],
        mounted() {
            this.loadStores();
        },
        methods: {
            print() {
                window.print();  
            },
            resetFilter() {
                this.disabledRest = true;
                this.loadData();
            },
            doFilter() {
                this.loadData();
            },
            changePage(page = 1) {
                this.previousPage = this.page;
                this.page = page;
                this.loadData();
            },
            async loadStores(){
                try {
                    const response = await this.$axios.get("admin/stores");
                    this.stores = response.data.data.stores;
                    this.disabled = false;
                } catch (e) {
                    this.$root.notify(e);
                } 
            },
            async loadData() {
                try {
                    const today = new Date();  
                    const startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);  

                    function formatDate(date) {  
                        const year = date.getFullYear();  
                        const month = String(date.getMonth() + 1).padStart(2, '0');  
                        const day = String(date.getDate()).padStart(2, '0');  
                        const hours = String(date.getHours()).padStart(2, '0');  
                        const minutes = String(date.getMinutes()).padStart(2, '0');  
                        const seconds = String(date.getSeconds()).padStart(2, '0');  

                        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;  
                    }  
                    if (!this.filterDate.startDate || !this.filterDate.endDate) {  
                        this.filterDate.startDate = formatDate(startOfToday);  
                        this.filterDate.endDate = formatDate(today);  
                    }  
                    this.disabled = true;
                    const home = await this.$axios.get("admin/home");
                    this.admin_id = home.data.data.admin.id;
                    const response = await this.$axios.get("admin/reports/cashiers-report-new", {
                        params: {
                            from_date: this.filterDate.startDate,
                            to_date: this.filterDate.endDate,
                            store_id: this.selectedStore ? this.selectedStore.id : '',
                        },  
                    });
                    this.reports = response.data.data.reports_today;
                    console.log(this.reports);
                    this.totals = response.data.data.totals;
                } catch (e) {
                    this.$root.notify(e);
                } finally {
                    this.disabled = false;
                }
            },
            showVarieties(productId) {
                this.$root.$emit("bv::show::modal", "show-varieties-modal");
                this.showVarietiesProductId = productId;
            },
        },
    };
</script>
<style>
    .print-only {
    display: none;
    }
    @media print {
        .not-in-print {
            display: none !important;
        }

        .app-content .side-app {
            padding: 0 !important;
        }

        .print-only {
            display: flex;
            justify-content: center; 
        }

        body * {
            visibility: hidden;
        }
        #print,
        #print * {
            visibility: visible;
            font-size: 1.25rem;
        }
        #print {
            padding: 0 !important;
        }
        #print {
            width: 100%;
        }

        #print .not-in-print {
            display: none;
        }

        .mr-2-print {
            margin-right: 20px;
        }
    }
</style>